export const CONTENT_PAGE_SIZE = 20;
export const CALENDAR_DAY_POSTS_LIMIT = 6;
